<template>
  <emd-modal
    :open="isOpen"
    has-header
    has-footer
    @close="$emit('onClose')"
  >
    <template v-slot:header>
      <h2 class="emd-text _size_section">
        {{ $t('modal.boleto-stone.modal-create-account.title') }}
      </h2>
    </template>
    <template v-slot:content>
      <p>
        {{ $t('modal.boleto-stone.modal-create-account.paragraph-1') }}
      </p>
    </template>
    <template v-slot:footer>
      <div class="footer-container">
        <a
          class="info-link"
          @click="$emit('onCreateAccount')"
        >
          {{ $t('modal.boleto-stone.modal-create-account.paragraph-2') }}
          <emerald-icon
            class="learn-more"
            icon="learn-more"
          />
        </a>

        <EmdButton
          color="primary"
          :text="$t('modal.boleto-stone.modal-create-account.button')"
          size="big"
          :block="true"
          class="button"
          @click="$emit('onCreateAccount')"
        />
      </div>
    </template>
  </emd-modal>
</template>

<script>
import { EmdModal, EmdButton, EmeraldIcon } from 'emerald-vue/src/components'

export default {
  name: 'ModalCreateAccount',
  components: {
    EmdModal,
    EmdButton,
    EmeraldIcon
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style scoped>
.footer-container {
  width: 100%;
}
.info-link {
  font-weight: 700;
  color: #72737a;
  font-size: 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.learn-more {
  margin-left: 12px;
}
.button {
  margin-top: 12px;
}
</style>
